import { AxiosResponse } from 'axios';
import axios from '../helpers/axios';
import { logError } from '../services';
import {
  IMissingDocumentTemplate,
  IResponse,
  IPandaDocContractActivity,
  PandaDocContractSort,
  PandaDocDocumentStatus,
  PandaDocActivityType,
  IDropdownResponse,
  IVendorContract,
  IVendorContractRes,
  IPandaDocReminder
} from '../models';
import qs from 'querystring';

export const downloadPandaDoc = async (docId: string): Promise<AxiosResponse> => {
  try {
    const res = await axios.get(`/api/panda-doc/documents/${docId}`, {
      responseType: 'blob'
    });
    return res;
  } catch (error) {
    logError(error, 'downloadPandaDoc failed');
    return Promise.reject(error);
  }
};

export const getMissingPandaDocTemplates = async (filters?: {
  query: string;
}): Promise<IMissingDocumentTemplate[]> => {
  try {
    const { data } = await axios.get(`/api/panda-doc/templates/missing`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getMissingPandaDocTemplates failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getContractActivity = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: PandaDocContractSort;
  sortDirection?: string;
  searchTerm?: string;
  documentStatus?: PandaDocDocumentStatus;
  activityType?: PandaDocActivityType;
  startCreatedDate?: string;
  endCreatedDate?: string;
}): Promise<IResponse<IPandaDocContractActivity[]>> => {
  try {
    const { data } = await axios.get(`/api/panda-doc/activity`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error) {
    logError(error, 'getVendorContractActivity failed');
    return Promise.reject(error);
  }
};

export const getContractActivityTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/panda-doc/activity-types`);
    return data;
  } catch (error) {
    logError(error, 'getContractActivityTypes failed');
    return Promise.reject(error);
  }
};

export const getInProgressPandaDocContracts = async (filters?: {
  vendorSageId?: string | number;
  vendorSearch?: string;
  pandaDocContractType?: string;
  pandaDocContractName?: string;
  startDate?: string;
  endDate?: string;
  contractAgeStart?: number | null;
  contractAgeEnd?: number | null;
  lastChangeStart?: string;
  lastChangeEnd?: string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}): Promise<IVendorContractRes<IVendorContract[]>> => {
  try {
    const { data } = await axios.get(`/api/panda-doc/in-progress`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getInProgressPandaDocContracts failed');
    return Promise.reject(error);
  }
};

export const sendPandaDocReminder = async (pandaDocDocumentId): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/panda-doc/${pandaDocDocumentId}/reminder-email`);
    return data;
  } catch (error) {
    logError(error, 'sendPandaDocReminder failed');
    return Promise.reject(error.response.data);
  }
};

export const getPandaDocReminderPreview = async (
  pandaDocDocumentId
): Promise<IPandaDocReminder> => {
  try {
    const { data } = await axios.get(`/api/panda-doc/${pandaDocDocumentId}/reminder-email/preview`);
    return data;
  } catch (error) {
    logError(error, 'getPandaDocReminderPreview failed');
    return Promise.reject(error.response.data);
  }
};
